<template>
  <div
    :style="customStyle"
    :class="{
      selected: selected,
      disabled: disabled,
    }"
    class="btn-color"
    @click="$emit('click')"
  >
    <img
      v-if="isShowCancelIcon"
      src="@/assets/icon/icon-disabled-color.png"
    />
  </div>
</template>

<script>
export default {
  computed: {
    customStyle() {
      return {
        backgroundColor:
          this.color.indexOf(`#`) > -1
            ? this.color
            : `#${this.color}`,
        height: `${this.height}px`,
        width: `${this.width}px`,
      }
    },
  },

  props: {
    color: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 40,
    },
    width: {
      type: Number,
      default: 40,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShowCancelIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-color
  border-radius: 50px
  box-shadow: 0 0 2px 1.5px white;
  border: 3px solid white;
  display: flex
  align-items: center
  justify-content: center
  box-shadow: inset 0 2px 3px 1px rgba(0,0,0,0.1);
  transition: 0.2s ease-in-out;
  position relative
  @media (hover: hover) and (pointer: fine)
    &:hover:not(.disabled):not(.selected)
      cursor: pointer
      transition: 0.2s ease-in-out;
  img
    width: 105%
    height: 105%
    position absolute
    top 50%
    left 50%
    transform: translate(-50%, -50%)
.btn-color.selected
     box-shadow: 0 0 0 2px $color-border-btn-spec;
     border: 3px solid #FFF;

.btn-color.disabled:not(.selected)
    box-shadow: none
    .sold-out
        color: red
        font-weight: bold
        font-size: 0.6rem
        text-shadow: 0 0 2px #fff;

.-is-bnn
	.btn-color
  		border-width: 6px
	.btn-color.selected
		box-shadow: 0 0 0 1.2px $color-border-btn-spec;
		border-width: 6px
</style>
